import React, { useEffect, useRef, useState } from "react";
import NotificationScreen from "./NotificationScreen"; // your existing screen
import NotificationIcon from "../../utils/Images/NotificationIcon";
import { t } from "i18next";
import "./NotificationPopover.scss";

interface NotificationPopoverProps {
  notificationCount: number;
  getNotificationCountApi: () => void;
}
const NotificationPopover: React.FC<NotificationPopoverProps> = ({
  notificationCount,
  getNotificationCountApi,
}) => {
  const [show, setShow] = useState(false);
  const popoverRef: any = useRef(null);
  const iconRef: any = useRef(null);
  const [, setTotalNotification] = useState(0);
  const togglePopover = () => {
    setShow((prevVisible) => !prevVisible);
  };
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        popoverRef.current &&
        !popoverRef.current.contains(event.target) &&
        iconRef.current &&
        !iconRef.current.contains(event.target)
      ) {
        setShow(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const notifyRef = useRef<any>(null);
  return (
    <div className="notificationPopover d-flex justify-content-center align-items-center p-3">
      <div className="bellIocn" ref={iconRef} onClick={togglePopover}>
        <NotificationIcon />
        {notificationCount ? (
          <span className="notificationCount">
            {notificationCount > 9 ? "9+" : notificationCount}
          </span>
        ) : null}
      </div>
      {show && (
        <div className="NotificationpopoverSec" ref={popoverRef}>
          <div className="popover-header" ref={notifyRef}>
            <div>
              <span className="popover-title">{t("GENERAL.NOTIFICATION")}</span>
            </div>
            {/* {totalNotification ? (
              <div className="bubbleWrap">
                <span className="notificationCountBubble">
                  {totalNotification}
                </span>
              </div>
            ) : null} */}
          </div>
          <div className="popover-body">
            <NotificationScreen
              notifyRef={notifyRef}
              setTotalNotification={setTotalNotification}
              getNotificationCountApi={getNotificationCountApi}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationPopover;
